import { StateAreas } from "./state-areas";

export const DEFAULT_SCOPE_INSTANCE_KEYS = {
  [StateAreas.Generic]: 'shared',
};